module.exports = __webpack_public_path__ + "static/dana-85aa80d0e8bc1614ee77b4fb8c606795.jpg";